(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modellhort-rabatt-leiste"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('modellhort-offers')) {
    customElements.define('modellhort-offers', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.timers = new Set();
        this.querySelectorAll('.mh-offers__copy').forEach(button => { button.hidden = false; });
        this.setAttribute('data-ready', '');
        this.addEventListener('click', async event => {
          const button = event.target.closest('.mh-offers__copy');
          if (!button || !this.contains(button) || button.disabled) return;
          const label = button.textContent;
          const status = this.querySelector('.mh-offers__status');
          status.textContent = '';
          button.disabled = true;
          try {
            await navigator.clipboard.writeText(button.dataset.code);
            button.textContent = this.dataset.success;
            status.textContent = this.dataset.success;
          } catch {
            button.parentElement.querySelector('.mh-offers__code').setAttribute('data-fallback', '');
            status.textContent = this.dataset.error;
          } finally {
            if (this.isConnected) {
              const timer = setTimeout(() => {
                button.textContent = label;
                button.disabled = false;
                this.timers.delete(timer);
              }, 1800);
              this.timers.add(timer);
            }
          }
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.timers?.forEach(clearTimeout);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
